import { BeginDiscordOAuthInput22qiqfp1mhdpr as BeginDiscordOAuthInput } from './schema/type/BeginDiscordOAuthInput.mjs';
import { BeginDiscordOAuthMutation2pm676kjmhe6s as BeginDiscordOAuthMutation } from './schema/BeginDiscordOAuthMutation.mjs';
import {
  DiscordOAuthState1jmuy0stlq7zq as DiscordOAuthState,
  Dispatcher1zt6xwq01e9iu as Dispatcher,
} from '../../../../../Coupling-libraries-action/com/zegreatrob/coupling/action/BeginDiscordOAuthCommand.mjs';
import { GqlTrait2wtoeyl3yfalb as GqlTrait } from './gql/GqlTrait.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *perform(command, $completion) {
  var tmp0_safe_receiver = (yield* this.i6y(new (BeginDiscordOAuthMutation())(new (BeginDiscordOAuthInput())(command.j2l_1, command.k2l_1)), $completion)).a45_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f6g_1;
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new (DiscordOAuthState())(tmp1_safe_receiver.g6g_1, tmp1_safe_receiver.h6g_1);
  }
  return tmp;
}
var SdkBeginDiscordOAuthClass;
function SdkBeginDiscordOAuth() {
  if (SdkBeginDiscordOAuthClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SdkBeginDiscordOAuth', VOID, VOID, [Dispatcher(), GqlTrait()], [1]);
    SdkBeginDiscordOAuthClass = $;
  }
  return SdkBeginDiscordOAuthClass;
}
//region block: exports
export {
  SdkBeginDiscordOAuth as SdkBeginDiscordOAuth3268k8540qta1,
  perform as perform2mul5h8tvg42t,
};
//endregion

//# sourceMappingURL=SdkBeginDiscordOAuth.mjs.map
